// Credit packages
export const CREDIT_PACKAGES = [
  { id: 'credit_1', name: 'Starter Pack', amount: 100, price: 99, bonus: 10, description: 'Perfect for trying out premium features', icon: '⚡' },
  { id: 'credit_2', name: 'Scooper Pack', amount: 500, price: 449, bonus: 50, popular: true, description: 'Best value for regular shoppers', icon: '👑' },
  { id: 'credit_3', name: 'Pro Pack', amount: 1000, price: 849, bonus: 150, description: 'For serious fashion enthusiasts', icon: '💎' },
  { id: 'credit_4', name: 'VIP Pack', amount: 5000, price: 3999, bonus: 1000, description: 'Ultimate VIP experience', icon: '🌟' },
];

// Tracking steps template
export const TRACKING_STEPS = [
  { id: 1, status: 'Order Placed', location: 'Online Store', date: 'Today', time: '10:30 AM', completed: true, details: 'Your order has been received' },
  { id: 2, status: 'Processing', location: 'Warehouse', date: 'Tomorrow', time: '9:00 AM', completed: false, details: 'Preparing your items for shipment' },
  { id: 3, status: 'Shipped', location: 'Distribution Center', date: '2 days', time: '2:00 PM', completed: false, details: 'Package has left our facility' },
  { id: 4, status: 'In Transit', location: 'Courier Van', date: '3 days', time: '11:00 AM', completed: false, details: 'On the way to your location' },
  { id: 5, status: 'Delivered', location: 'Your Address', date: '4 days', time: '3:00 PM', completed: false, details: 'Package delivered successfully' },
];

// Legal documents
export const LEGAL_DOCUMENTS = [
  { id: 'terms', title: 'Terms of Service', content: 'By using Scoop, you agree to our terms...', version: '2.1', updatedAt: new Date('2024-01-15') },
  { id: 'privacy', title: 'Privacy Policy', content: 'We value your privacy and protect your data...', version: '1.4', updatedAt: new Date('2024-01-10') },
  { id: 'cookies', title: 'Cookie Policy', content: 'We use cookies to enhance your experience...', version: '1.2', updatedAt: new Date('2024-01-05') },
  { id: 'returns', title: 'Return Policy', content: '30-day return policy for unused items...', version: '1.3', updatedAt: new Date('2024-01-01') },
];

// App constants
export const APP_NAME = 'Scoop';
export const APP_SLOGAN = 'The streets are watching';
export const CURRENCY = 'ZAR';
export const SHIPPING_FEE = 99;
export const FREE_SHIPPING_THRESHOLD = 1000;
export const TAX_RATE = 0.15;